import { masterApi } from './api';

export default async function fetchCountriesData({ accessToken }) {
	const res = await masterApi.get('/country', {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			accept: '*/*',
		},
	});

	return res?.data;
}
